<template lang="pug">
#heatmap_event
  table.table
    tbody
      tr
        th ブラウザバック
        td {{ pop_state }} %
      tr
        th 別ウィンドウ移動
        td {{ blur }} %
      tr
        th クリック
        td {{ click }} %
      tr
        th その他
        td {{ other }} %

</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  props: {
    state_name: {
      type: String,
      default: "heatmap"
    },
  },
  data() {
    return {
    }
  },
  computed: {
    pop_state() {
      return this.$store.state[this.state_name].event_data.pop_state;
    },
    click(){
      return this.$store.state[this.state_name].event_data.click;
    },
    blur(){
      return this.$store.state[this.state_name].event_data.blur;
    },
    other(){
      return this.$store.state[this.state_name].event_data.other;
    },
  }
}
</script>
